// extracted by mini-css-extract-plugin
export const statsRoot = "bj_6";